import { disablePageScroll, enablePageScroll } from "scroll-lock";

function toggleSearch() {
  let button = $('.header__trigger');
  let search = $('.header__search');
  let back = $('.header__back');
  let dropdown = $('.search-dropdown');
  let dropdownWrapper = $('.search-dropdown__wrapper');

  $('.header__search input').on('input', function() {
    if ($(this).val() !== '') {
      $(this).addClass('filled');
    } else {
      $(this).removeClass('filled');
    }
  });

  button.on('click', function() {
    disablePageScroll();
    search.addClass('active');
    dropdown.addClass('active');
  });
  back.on('click', function() {
    enablePageScroll();
    search.removeClass('active');
    dropdown.removeClass('active');
  });
  $('.header__search input').on('focus', function() {
    disablePageScroll();
    search.addClass('active');
    dropdown.addClass('active');
  });
  $(document).mouseup(function(e) {
    if (!dropdownWrapper.is(e.target) && !search.is(e.target) && search.has(e.target).length === 0 && dropdownWrapper.has(e.target).length === 0) {
      dropdown.removeClass('active');
      search.removeClass('active');
      enablePageScroll();
    }
  });
  
}
toggleSearch();